export default __webpack_public_path__ + "static/media/item1.bc1d19f1.png";